// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  maintenanceMode: false,
  debugMode: true,
  skipAuthGuard: true,
  testingMode: true,
  userMail: 'sebasjb3@gmail.com' ,
  voyjaleasConfigUrl: 'https://dashboard.voyjaleas.com/voyjaleasConfig/',
  apiClient: 'dashboard',
  apiKey: '12345',
  apiUrl: 'https://api.voyjaleas.com',
  urlDash: 'https://dashboard.voyjaleas.com',
  assetsWorkerUrl: 'https://voyjaleas-assets-worker.sebtec12.workers.dev/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
